import script from "./SwipeRefresh.vue?vue&type=script&setup=true&lang=ts"
export * from "./SwipeRefresh.vue?vue&type=script&setup=true&lang=ts"

import "./SwipeRefresh.vue?vue&type=style&index=0&id=2bd38910&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bd38910"]])

export default __exports__